import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { MdOutlineNavigateBefore, MdOutlineNavigateNext } from 'react-icons/md';
import Carousel from 'react-simply-carousel';
import DonutChartWithLabel, {
  IDonutChartWithLabelProps,
} from '../donutChartWithLabel/DonutChartWithLabel';

interface IProps {
  donutChartData: IDonutChartWithLabelProps[] | undefined;
}

const DonutChartCarousel = (props: IProps) => {
  const { donutChartData } = props;
  const [activeSlide, setActiveSlide] = useState(0);

  if (!donutChartData) {
    return <></>;
  }

  return (
    <Row className='justify-content-center mt-3'>
      <Col className={donutChartData.length === 1 ? 'col-auto' : 'col-12'}>
        <Carousel
          containerProps={{
            style: {
              width: '100%',
              justifyContent: 'space-between',
              userSelect: 'text',
            },
          }}
          activeSlideIndex={activeSlide}
          onRequestChange={setActiveSlide}
          backwardBtnProps={{
            children: activeSlide !== 0 && (
              <MdOutlineNavigateBefore size={30} color='#004888' />
            ),
            style: {
              alignSelf: 'center',
              border: 'none',
              background: 'white',
            },
          }}
          forwardBtnProps={{
            children: activeSlide !== donutChartData.length - 1 && (
              <MdOutlineNavigateNext size={30} color='#004888' />
            ),
            style: {
              alignSelf: 'center',
              border: 'none',
              background: 'white',
            },
          }}
          dotsNav={{
            show: false,
          }}
          itemsToShow={1}
          speed={400}
          infinite={false}
        >
          {donutChartData.map((data: IDonutChartWithLabelProps, index) => {
            return <DonutChartWithLabel key={index} {...data} />;
          })}
        </Carousel>
      </Col>
    </Row>
  );
};

export default DonutChartCarousel;
